/**
 * Maps hostnames to a specific citySlug + vertical.
 * When a visitor hits one of these domains, the app locks into
 * single-collective mode — no access to other collectives.
 *
 * Add a new entry here whenever a new dedicated domain goes live.
 *
 * Format:
 *   'domain.com': { citySlug: 'city-vertical-id', vertical: 'vertical-id', label: 'Display Name' }
 *
 * citySlug must match the `slug` column in the cities_1715634000000 table.
 * vertical must match an id in verticals.js.
 */
export const DOMAIN_MAP = {
  // --- Event Planning ---
  // 'surprise-events.com':       { citySlug: 'surprise',                vertical: 'event-planning', label: 'Surprise' },
  // 'goodyear-events.com':       { citySlug: 'goodyear',                vertical: 'event-planning', label: 'Goodyear' },
  // 'peoria-events.com':         { citySlug: 'peoria-event-planning',   vertical: 'event-planning', label: 'Peoria' },

  // --- Home Services ---
  // 'surprise-homeservices.com': { citySlug: 'surprise-home-services',  vertical: 'home-services',  label: 'Surprise' },

  // --- Health & Wellness ---
  // 'surprise-wellness.com':     { citySlug: 'surprise-health-wellness',vertical: 'health-wellness',label: 'Surprise' },

  // --- Restaurants ---
  // 'surprise-dining.com':       { citySlug: 'surprise-restaurants',    vertical: 'restaurants',    label: 'Surprise' },

  // --- Real Estate ---
  // 'surprise-realty.com':       { citySlug: 'surprise-real-estate',    vertical: 'real-estate',    label: 'Surprise' },
  'sterlingheights.us': { citySlug: 'sterling-heights-event-planning', vertical: 'event-planning', label: 'Sterling Heights' },
};

/**
 * Returns the collective config for the current hostname,
 * or null if this is the main mailboxflyers site.
 */
export function getCollectiveFromDomain() {
  const host = window.location.hostname.replace(/^www\./, '');
  return DOMAIN_MAP[host] ?? null;
}
